/**
 * Adres çubuğu = liste durumu (filtre, sayfa, sıra).
 *
 * Neden state değil: kullanıcı bağlantıyı paylaşır, geri tuşuna basar, sayfayı
 * yeniler — hepsinde aynı liste açılmalı. Filtre değişince sayfa 1'e döner:
 * 2. sayfadayken filtre daraltılırsa boş liste gelirdi.
 *
 * Ölçülen tekrar: aynı 9 satır dört liste ekranında vardı (FaturaListesi,
 * HataKayitlari, GonderimKayitlari, DenetimKaydi).
 */

import { useSearchParams } from 'react-router';

export function useAdresParametreleri() {
  const [parametreler, setParametreler] = useSearchParams();

  /** Verilen anahtarları yazar; `undefined`/boş olanı siler. */
  const adresiGuncelle = (yama: Record<string, string | number | undefined>, sayfayiSifirla = true) => {
    const yeni = new URLSearchParams(parametreler);
    for (const [anahtar, deger] of Object.entries(yama)) {
      if (deger === undefined || deger === '') yeni.delete(anahtar);
      else yeni.set(anahtar, String(deger));
    }
    if (sayfayiSifirla) yeni.delete('page');
    setParametreler(yeni);
  };

  return { parametreler, setParametreler, adresiGuncelle };
}
